import { defineStore } from 'pinia'
//import { getCurrentInstance } from 'vue'
//import type { ApiClient } from '@/api/client';
//import { ApiClientKey } from '@/main';
//import { inject } from 'vue'
import { api } from '@/main'

export const useGlobalStore = defineStore('global', {
  state: () => {
    return {
      isSidebarMinimized: false,
      token: '',
      ip: '',
      refresh: '',
      fullname: '',
      email: '',
      api: '',
      menus: [],
      avatar: '',
    }
  },

  actions: {
    toggleSidebar() {
      this.isSidebarMinimized = !this.isSidebarMinimized
    },
    storeToken(token = '', refresh = '') {
      ;(this.token = token), (this.refresh = refresh)
    },
    storeIP(ip = '') {
      this.ip = ip
    },
    storeFullname(fullname = '') {
      this.fullname = fullname
    },
    storeAvatar(avatar = '') {
      this.avatar = avatar
    },
    storeEmail(email = '') {
      this.email = email
    },
    checkState() {
      if (this.token != '') {
        this.token = this.refresh
        api.post('auth/logout').then(() => {
          this.avatar = ''
          this.email = ''
          this.token = ''
          this.refresh = ''
          this.ip = ''
          this.menus = []
        })
      }
    },
    getApi() {
      //      if (this.api=='')return;
      //      return JSON.parse(this.api)
      //        const api = inject<ApiClient | null>(ApiClientKey, null);
      return api
    },
    storeMenus(menus = []) {
      this.menus = menus
    },
  },
  persist: true,
})
